module.exports = __webpack_public_path__ + "static/img/znzz3.9d33aed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/znzz3.jpg
// module id = EiIp
// module chunks = 0